import HowToBuyCar from 'apps/HowToBuyCar'
import { financingFaqs, makesSYC, htbFaqs } from 'vars'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'
import htbMessages from 'lang/es/how-to-buy-car'
import { safePromise } from 'utils/universal/safePromise'
import axios from 'axios'
import get from 'lodash/get'
import { internalSectionMapper, timelineAndVideoMapper } from 'mappers/commonMapper'

export default HowToBuyCar

export const getStaticProps = async () => {
  const commonStaticProps = await getCommonStaticProps()
  const url = `${process.env.NEXT_PUBLIC_API_WORDPRESS}/acf/v3/options/home`
  const { result } = await safePromise(axios(url))
  const internalSections = get(result, 'data.acf.internal_sections', [])
  const buyCarTimeline = get(result, 'data.acf.buyacar_timeline', {})

  const messages = {
    ...commonMessages,
    ...htbMessages,
  }

  return {
    props: {
      titleMeta: 'HTB_TITLE',
      descriptionMeta: 'HTB_DESCRIPTION',
      financingFaqs,
      makesSYC,
      htbFaqs,
      headerProps: {
        activeIndex: 2,
        whatsappMessage: {
          id: 'CONTACT_WHATSAPP_MESSAGE',
        },
      },
      messages,
      ...commonStaticProps,
      internalSections: internalSectionMapper(internalSections),
      buyCarTimeline: timelineAndVideoMapper(buyCarTimeline),
    },
  }
}
